import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function YoutubeDownloader() {
  useEffect(() => {
    document.title = 'YouTube Video Downloader — Download YouTube Videos in HD MP4';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Download YouTube videos in HD, Full HD, and 4K quality. Save YouTube videos as MP4 or convert to MP3 for free. No registration needed.');

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: 'How to Download YouTube Videos',
      step: [
        { '@type': 'HowToStep', position: 1, text: 'Copy the YouTube video URL from the address bar or share button.' },
        { '@type': 'HowToStep', position: 2, text: 'Paste the URL into the input field on HD Video Download.' },
        { '@type': 'HowToStep', position: 3, text: 'Select your preferred quality (240p to 4K) and format (MP4 or MP3), then download.' },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <div className="app">
      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>
        <h1 className="page-title">YouTube Video Downloader</h1>
        <p className="page-subtitle">Download YouTube videos in HD, 4K, MP4 and MP3 for free.</p>

        <div className="cta-section" style={{ marginTop: '1.5rem', marginBottom: '2rem' }}>
          <Link to="/" className="cta-btn">Download YouTube Video Now</Link>
        </div>

        <h2 className="section-title">How to Download YouTube Videos</h2>
        <div className="steps">
          <div className="step">
            <span className="step-number">1</span>
            <div>
              <h3>Copy YouTube Video URL</h3>
              <p>Open YouTube, find the video you want to download, and copy the URL from the address bar. You can also tap the Share button and copy the link on mobile.</p>
            </div>
          </div>
          <div className="step">
            <span className="step-number">2</span>
            <div>
              <h3>Paste URL & Fetch Formats</h3>
              <p>Go to hdvideodownload.com and paste the YouTube URL. Click "Download" to see all available quality options from 240p up to 4K resolution.</p>
            </div>
          </div>
          <div className="step">
            <span className="step-number">3</span>
            <div>
              <h3>Choose Quality & Download</h3>
              <p>Select MP4 for video or MP3 for audio only. Pick your preferred resolution — 720p, 1080p Full HD, or even 4K. Your file will download automatically.</p>
            </div>
          </div>
        </div>

        <h2 className="section-title">YouTube Download Features</h2>
        <div className="seo-features">
          <div className="seo-feature">
            <h3>4K & HD Quality</h3>
            <p>Download YouTube videos in the highest available quality — from 240p to 4K Ultra HD resolution.</p>
          </div>
          <div className="seo-feature">
            <h3>MP3 Audio Extract</h3>
            <p>Convert YouTube videos to MP3 audio files. Perfect for saving music, podcasts, and lectures.</p>
          </div>
          <div className="seo-feature">
            <h3>YouTube Shorts</h3>
            <p>Download YouTube Shorts videos as regular MP4 files to watch offline on any device.</p>
          </div>
        </div>

        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="platform-list">
          <div className="platform-item">
            <h3>Is it free to download YouTube videos?</h3>
            <p>Yes, our YouTube video downloader is completely free. No registration, no limits, no hidden costs.</p>
          </div>
          <div className="platform-item">
            <h3>What quality options are available?</h3>
            <p>We offer all qualities available on YouTube: 240p, 360p, 480p, 720p HD, 1080p Full HD, 1440p, and 4K depending on the original video.</p>
          </div>
          <div className="platform-item">
            <h3>Can I download YouTube music as MP3?</h3>
            <p>Yes, select the MP3 format option to extract only the audio from any YouTube video.</p>
          </div>
          <div className="platform-item">
            <h3>Why does YouTube download take longer?</h3>
            <p>YouTube videos require server-side processing which may take 1-2 minutes depending on the video length and quality selected.</p>
          </div>
        </div>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Download YouTube Videos Free</Link>
        </div>
      </div>

      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default YoutubeDownloader;
